import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/**
 * Small callout for a single derived fact ("21 tenants on plans with no
 * assigned status", "3 licenses missing a price"). Meant for surfacing
 * a computed insight from already-fetched data, not a KPI.
 */
const InsightCard = ({ icon: Icon, title, description, tone = 'muted', action, className }) => {
  const toneClass = {
    muted: 'bg-muted/60 text-foreground',
    // `text-foreground`, matching every other tone here. It was
    // `text-warning-foreground` — the ink for a SOLID amber fill — over a
    // 10% tint, which in dark is near-black on near-black at 1.06:1. The
    // tint and the border carry the tone; the title does not have to.
    warning: 'bg-warning/10 text-foreground border-warning/30',
    success: 'bg-success/10 text-foreground border-success/30',
    primary: 'bg-primary/5 text-foreground border-primary/20',
  }[tone] || 'bg-muted/60 text-foreground';

  return (
    <Card className={cn('flex items-start gap-3 border p-3.5', toneClass, className)}>
      {Icon && <Icon className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />}
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium leading-tight">{title}</p>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
      {action}
    </Card>
  );
};

export default InsightCard;
